/** A run of the candidate-sourcing pipeline for a job — mirrors the
 * backend `sourcing.SourcingRun` model. The Longlist polls a job's
 * latest run while it is active to show pipeline progress. */

export const SOURCING_RUN_STATUSES = [
  "queued",
  "finding",
  "enriching",
  "scoring",
  "analyzing",
  "done",
  "partial",
  "failed",
  // An admin ended it early (#88); what it found is kept.
  "stopped",
] as const;
export type SourcingRunStatus = (typeof SOURCING_RUN_STATUSES)[number];

/** Statuses where the pipeline is still working — the UI polls while the
 * run is in one of these. */
export const SOURCING_ACTIVE_STATUSES: readonly SourcingRunStatus[] = [
  "queued",
  "finding",
  "enriching",
  "scoring",
  "analyzing",
];

export function isSourcingActive(status: SourcingRunStatus): boolean {
  return SOURCING_ACTIVE_STATUSES.includes(status);
}

export interface SourcingRun {
  id: string;
  job: string;
  status: SourcingRunStatus;
  foundCount: number;
  enrichedCount: number;
  scoredCount: number;
  findLimit: number;
  error: string | null;
  startedAt: string | null;
  finishedAt: string | null;
  /** Set when an admin asked the running search to stop (#88). */
  stopRequestedAt: string | null;
  createdAt: string;
  updatedAt: string;
}
